import Vue                 from 'vue';
import resultsList         from './results/list.vue';
import resultsLoading      from './results/loading.vue';
import textBanner          from './text/banner.vue';
import textSubmitButton    from './text/submit-button.vue';
import textTitle           from './text/title.vue';
import textFaq             from './text/faq.vue';
import searchForm          from './search-form.vue';
import searchFilterAdd     from './filters/add.vue';
import searchFilterDelete  from './filters/delete.vue';
import searchFilterSearch  from './filters/search.vue';
import resultsOrder        from './filters/order.vue';
import newsletterSubscribe from '../newsletter-subscribe.vue';
import paginationBar       from '../pagination-bar.vue';
import flashBag            from '../flash-bag.vue';
import vueSearchBase       from '../../../../common/vue/vue-search-base';
import loginHouseCountText from "./text/login-house-count-text.vue";

Vue.component('adivare-rentals-list', resultsList);
Vue.component('adivare-text-banner', textBanner);
Vue.component('adivare-login-house-count-text', loginHouseCountText);
Vue.component('adivare-text-submit-button', textSubmitButton);
Vue.component('adivare-text-title', textTitle);
Vue.component('adivare-text-faq', textFaq);
Vue.component('adivare-results-order', resultsOrder);
Vue.component('adivare-search-form', searchForm);
Vue.component('adivare-filter-add', searchFilterAdd);
Vue.component('adivare-filter-delete', searchFilterDelete);
Vue.component('adivare-filter-search', searchFilterSearch);
Vue.component('adivare-newsletter-subscribe', newsletterSubscribe);
Vue.component('adivare-results-loading', resultsLoading);
Vue.component('adivare-pagination-bar', paginationBar);
Vue.component('adivare-flash-bag', flashBag);
vueSearchBase();
